import { render, staticRenderFns } from "./team-switcher.vue?vue&type=template&id=f2d28ff2&"
import script from "./team-switcher.vue?vue&type=script&lang=js&"
export * from "./team-switcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports